var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "blocked-ip-container" }, [
    _c("div", { staticClass: "blocked-ip-title" }, [
      _vm._v(_vm._s(_vm.$t("blockedIp.title"))),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "blocked-ip-description" }, [
      _vm._v(_vm._s(_vm.$t("blockedIp.description"))),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "blocked-ip-suggestion" }, [
      _vm._v(
        _vm._s(
          _vm.$t("blockedIp.suggestion", { ip: _vm.user.lastLoginIPAddress })
        )
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }